import React from 'react';
import { Button, Flex, Result } from 'antd';
import { useNavigate } from 'react-router-dom';
import "./Page404.css"
const Page404 = () => {
    const navigate = useNavigate();

    const handleButtonClick = () => {
        navigate(-1);
    };

    return (
        <Flex align='center' justify='center' style={{
            background: "var(--base-colorbase-color-02)",
            width: "100vw",
            height: "100vh"
        }}>
            <Result

                status="404"
                title="404"
                subTitle="Desculpe, a página que você visitou não existe."
                extra={
                    <Button danger style={{
                        width: 300,
                        height: 50,
                        fontSize: 24,
                    }}
                        onClick={handleButtonClick}>Voltar</Button>
                }
            />
        </Flex>

    );
};

export default Page404;